/**
 * Created by tofael on 8/6/18.
 */
import React from 'react';
import {PieChart, Pie, Text, Legend, Tooltip, Cell, ResponsiveContainer} from 'recharts';


const styles = {
  root: {
    background: '#ffffff',
    padding: 10
  },
  tooltip:{
    background: '#ffffff',
    padding: 20
  }
};
const RADIAN = Math.PI / 180;

const renderLabel = (props) => {

  const {cx, cy, midAngle, innerRadius, outerRadius, percent, index, payload} = props;
  const radius = innerRadius + (outerRadius - innerRadius) * 1.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <Text width={150} x={x} y={y} fill={props.fill} textAnchor={x > cx ? 'middle' : 'middle'} dominantBaseline="central" key={index}>
      {
        `${payload.value}(${(percent * 100).toFixed(0)}%)`
      }

    </Text>
  )
};

const PieChartComponent = ({title, data, dataKey}) => (
  <div style={styles.root}>
    <h3>{title}</h3>
    <ResponsiveContainer width='100%' height={400}>
    <PieChart>
      <Legend verticalAlign="top"/>
      <Pie dataKey="value" data={data} cx={200} cy={200} outerRadius={80} fill="#8884d8" label={renderLabel} paddingAngle={2} minAngle={2}>
        {
          data.map((entry, index) => <Cell fill={entry.color}/>)
        }
      </Pie>
      <Tooltip/>
    </PieChart>
    </ResponsiveContainer>
  </div>
);
export default PieChartComponent;


// WEBPACK FOOTER //
// ./src/screens/stats/pie-chart.js